import React from "react";
import "./index.css";

const Loader = ({ color, size }) => {
  return (
    <>
      <svg className={size === "sm" ? "inline-loader-sm" : "inline-loader"}>
        <circle
          className={
            size === "sm" ? "inline-loader-circle-sm" : "inline-loader-circle"
          }
          stroke={color ? color : "#52aee4"}
        />
      </svg>
    </>
  );
};

export default Loader;
